import { render, staticRenderFns } from "./alice.vue?vue&type=template&id=33a1b744"
import script from "./alice.vue?vue&type=script&lang=js"
export * from "./alice.vue?vue&type=script&lang=js"
import style0 from "./alice.vue?vue&type=style&index=0&id=33a1b744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports